package er.prateek.crossly.ui.screens.legal

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import crossly.shared.generated.resources.Res
import crossly.shared.generated.resources.settings_privacy_policy
import er.prateek.crossly.ui.components.GameScreen
import er.prateek.crossly.ui.components.GameTopBar
import er.prateek.crossly.ui.theme.Spacing
import er.prateek.crossly.ui.theme.game
import org.jetbrains.compose.resources.stringResource

@Composable
fun PrivacyPolicyScreen(onBack: () -> Unit) {
    val colors = MaterialTheme.game
    var loading by remember { mutableStateOf(true) }
    val url = remember { currentPrivacyPolicyUrl() }

    GameScreen(padded = false) {
        Column(modifier = Modifier.fillMaxSize()) {
            GameTopBar(
                title = stringResource(Res.string.settings_privacy_policy),
                onBack = onBack,
                modifier = Modifier.padding(Spacing.lg),
            )
            Box(modifier = Modifier.fillMaxSize()) {
                WebViewContent(
                    url = url,
                    modifier = Modifier.fillMaxSize(),
                    onLoadingChanged = { loading = it },
                )
                if (loading) {
                    CircularProgressIndicator(
                        color = colors.accent,
                        modifier = Modifier.align(Alignment.Center),
                    )
                }
            }
        }
    }
}
